import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import colors from "../../design/colors";

// 로그인 전 화면의 로고 헤더. 카리아카 BlankHeader 와 같은 자리에 카리페이 로고를 둔다.
const BlankHeader = () => {
  const navigate = useNavigate();
  return (
    <Header>
      <img
        src="/logo-pay.svg"
        alt="카리페이"
        width={159}
        height={30}
        onClick={() => navigate("/login")}
        style={{ cursor: "pointer" }}
      />
    </Header>
  );
};

export default BlankHeader;

const Header = styled.div`
  position: relative;
  height: 66px;
  width: 100%;
  background-color: ${colors.white};
  display: flex;
  align-items: center;
  max-width: 1024px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;

  /* 1024px 이하에선 헤더가 화면 끝에 붙어 -6px 이면 로고 왼쪽이 잘린다 */
  @media screen and (max-width: 1024px) {
    left: 0;
    padding: 0 20px;
  }
`;
